import { isEmpty } from 'lodash';
import React from 'react';
import { useParams } from 'react-router-dom';

import '../../../styles/chartInfoTable.scss';
import { PbBody, PbCell, PbHead, PbRow, PbTable } from '../../../shared/components/table';
import { chartInfoTableData } from '../../../shared/constants/api';
import { IChartInformation } from '../../../shared/interface';

interface IProps {
	className?: string;
	information: IChartInformation;
	language: string;
	length: number;
}

const ChartInformationTable: React.FC<IProps> = (props) => {
	const { information, language, length } = props;
	const params = useParams();

	const chartUpdate: { [key: string]: string } = {
		D: `${language === 'en' ? 'Daily' : 'Täglich'}`,
		M: `${language === 'en' ? 'Monthly' : 'Monatlich'}`,
		W: `${language === 'en' ? 'Weekly' : 'Wöchentlich'}`,
		Q: `${language === 'en' ? 'Quarterly' : 'Quartalsweise'}`
	};

	return (
		<PbTable className={`chart-information-table`} tableClassName={`${length >= 2 ? 'width-70' : 'width-full'}`}>
			<PbHead className='information-header'>
				<PbRow>
					<PbCell className='table-head ' colSpan={2} header>
						{language === 'en' ? 'Informations' : 'Informationen'}
					</PbCell>
				</PbRow>
			</PbHead>
			<PbBody>
				{!isEmpty(information) &&
					chartInfoTableData(information, language, chartUpdate, params.token as string).map((info) => {
						const { Icon } = info;
						return (
							<PbRow key={info.label}>
								<PbCell className='item-label'>
									<div>
										<span className='mr-10'>
											<Icon />
										</span>
										{info.label}
									</div>
								</PbCell>
								<PbCell className='item-value '>{info.value}</PbCell>
							</PbRow>
						);
					})}
			</PbBody>
		</PbTable>
	);
};

export default ChartInformationTable;
